/**
 * Inbound URL params we capture and forward onto internal CTA links (today the
 * recruiterId referral id). This list is the single extension point: add a key
 * here and middleware capture, the cookie, and the CTA href rewrite all pick it
 * up.
 */
export const FORWARDED_URL_PARAMS = ["recruiterId"] as const;

export const FWD_PARAMS_COOKIE_NAME = "pc_fwd_params";

export const FWD_PARAMS_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 30;
